import React, { useState } from 'react';
// CSS Styles
import './Tabs.css';
import Layout from "../../Layout";
import TaskTable from './Tables/TaskTable'
import { MyTasktable } from '../../components/Tables';

import {
    MyTaskData
} from '../../components/Datas';
import Summary from './Tables/Summary';

const Tabs = () => {
    const [activeTab, setActiveTab] = useState(0);
    const [activeTabWorkLog, setActiveTabWorkLog] = useState(0);

    const handleTabClick = (index) => {
        setActiveTab(index);
    };
    const handleTabClickWorkLog = (index) => {
        setActiveTabWorkLog(index);
    };

    const tasksInProgress = [
        { id: 1, name: "Task 1", status: "In Progress" },
        { id: 2, name: "Task 2", status: "In Progress" },
    ];

    const scheduledTasks = [
        // { id: 3, name: "Task 3", status: "Scheduled" },
        // { id: 4, name: "Task 4", status: "Scheduled" },
    ];

    return (
        <Layout>
            <div className="tabs-container">
                <div className="tabs">
                    <div
                        className={`tab ${activeTab === 0 ? 'active' : ''}`}
                        onClick={() => handleTabClick(0)}
                    >
                        My Tasks
                    </div>
                    <div
                        className={`tab ${activeTab === 1 ? 'active' : ''}`}
                        onClick={() => handleTabClick(1)}
                    >
                        Work Logs
                    </div>
                </div>
                <div className="tab-content">
                    {activeTab === 0 && (
                        <div className="container">
                            <div className="w-full grid xl:grid-cols-6 grid-cols-1 gap-6">
                                <div className="xl:col-span-6  w-full">
                                    {/* Task */}
                                    <div className="mt-6 bg-white rounded-xl border-[1px] border-border p-5">
                                        {/* title */}
                                        <div className="flex gap-4 items-center">
                                            <h2 className="text-sm font-medium">IN PROGRESS</h2>
                                        </div>
                                        {/* table */}
                                        <div className="mt-4 overflow-x-scroll">

                                            <MyTasktable
                                                data={MyTaskData.slice(0, 5)}
                                                action={false}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="w-full my-6 grid xl:grid-cols-6 grid-cols-1 gap-6">
                                <div className="xl:col-span-6  w-full">
                                    {/* Task */}
                                    <div className="mt-6 bg-white rounded-xl border-[1px] border-border p-5">
                                        {/* title */}
                                        <div className="flex gap-4 items-center">
                                            <h2 className="text-sm font-medium">SCHEDULED TASKS</h2>
                                        </div>
                                        {/* table */}
                                        <div className="mt-4 overflow-x-scroll">
                                            <MyTasktable
                                                data={MyTaskData.slice(0, 5)}
                                                action={false}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    )}
                    {activeTab === 1 && (
                        <>
                            <div className="tabs-container">
                                <div className="tabs">
                                    <div
                                        className={`tabBackground ${activeTabWorkLog === 0 ? 'active' : ''}`}
                                        onClick={() => handleTabClickWorkLog(0)}
                                    >
                                        Table
                                    </div>
                                    <div
                                        className={`tabBackground ${activeTabWorkLog === 1 ? 'active' : ''}`}
                                        onClick={() => handleTabClickWorkLog(1)}
                                    >
                                        Summary
                                    </div>
                                </div>
                            </div>

                            <div className="container">
                                {activeTabWorkLog === 0 && (
                                    <div className="container">
                                        <div className="w-full my-6 grid xl:grid-cols-6 grid-cols-1 gap-6">
                                            <div className="xl:col-span-6  w-full">
                                                {/* Task */}
                                                <div className=" bg-white rounded-xl border-[1px] border-border p-5">
                                                    <div className="">
                                                        <TaskTable
                                                            data={MyTaskData.slice(0, 5)}
                                                            action={false}
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                )}
                                {activeTabWorkLog === 1 && (
                                    <div className="container mx-auto p-4">
                                        <Summary />
                                    </div>
                                )}
                            </div>
                        </>
                    )}
                </div>
            </div>
        </Layout>
    );
};

export default Tabs;


